// @flow

// fragment == src/queries/errorFragment.gql
export default function messageFromErrorFragment(error: *): string {
  if (!error) {
    return 'An error occurred.';
  }

  if (error.code === 'validation_error') {
    const errors = error.fieldErrors || [];
    const messages = errors.map(err => err.message).filter(Boolean);

    if (messages.length > 0) {
      return messages.join(', ');
    }
  }

  if (error.message) {
    return error.message;
  }

  return 'An error occurred.';
}
